import { ReceiptText } from "@squareup/sq-addons-web-sdk";
import { posContextSelector } from 'store/context';
import {useSelector} from "react-redux";

/**
 * Builds a digital receipt object.
 *
 * @returns The digital receipt object.
 */
export function buildDigitalReceipt(): ReceiptText | null {
  const posContext = useSelector(posContextSelector);
  const addonName = posContext?.configurations?.addonName || 'LAVA Loyalty';
  let title = `Thanks for being a ${addonName} Member!`;
  let body = `You received a discount on this purchase.`;

  return {
    title,
    body,
    url: "",
    urlText: ``,
  };
}

/**
 * Builds a printed receipt object.
 *
 * @returns The printed receipt object.
 */
export function buildPrintedReceipt(): ReceiptText {
  const posContext = useSelector(posContextSelector);
  const addonName = posContext?.configurations?.addonName || 'LAVA Loyalty';
  let title = `Thanks for being a ${addonName} Member!`;
  let body = `You received a discount on this purchase.`;

  return {
    title,
    body,
    url: "",
  };
}
